/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _Promise = require('babel-runtime/core-js/promise')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _settings = require('../../settings');

var _settings2 = _interopRequireDefault(_settings);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _reduxModulesContributors = require('redux/modules/contributors');

var _lodashIsEmpty = require('lodash/isEmpty');

var _lodashIsEmpty2 = _interopRequireDefault(_lodashIsEmpty);

var _lodashFind = require('lodash/find');

var _lodashFind2 = _interopRequireDefault(_lodashFind);

var Contributors = (function (_Component) {
	_inherits(Contributors, _Component);

	function Contributors() {
		_classCallCheck(this, _Contributors);

		_Component.apply(this, arguments);

		this.state = {
			mostPopularIsStuck: false,
			mostPopularIsStuckToBottom: false,
			showSidebar: false
		};
	}

	Contributors.fetchData = function fetchData(getState, dispatch) {
		var promises = [];

		if (!_reduxModulesContributors.isLoaded(getState())) {
			promises.push(dispatch(_reduxModulesContributors.load()));
		}

		return _Promise.all(promises);
	};

	Contributors.prototype.render = function render() {
		var _classNames;

		var styles = require('./Contributors.css');
		var _props = this.props;
		var articles = _props.articles;
		var params = _props.params;

		var contentStyles = _classnames2['default']((_classNames = {}, _classNames[styles['Content--main']] = true, _classNames.CMSContent = true, _classNames));

		var article = undefined;

		// Get the user data based on the param provided
		if (_lodashIsEmpty2['default'](params)) article = articles[0];else {
			article = _lodashFind2['default'](articles, { 'slug': params.contributor });
		}

		var photo = article.photos['bbrew-small'].length ? '' + _settings2['default'].cdn + article.photos['bbrew-small'][0] : article.avatar;

		return _react2['default'].createElement(
			'main',
			{ className: styles.Base },
			_react2['default'].createElement(_reactHelmet2['default'], { title: 'Contributors: ' + article.fullname }),
			_react2['default'].createElement(
				'section',
				{ className: styles.Contributor },
				_react2['default'].createElement(
					'header',
					{ className: styles.Header },
					_react2['default'].createElement(
						'figure',
						{ className: styles.Figure },
						_react2['default'].createElement('img', { className: styles.FigureImage, src: photo })
					),
					_react2['default'].createElement(
						'hgroup',
						{ className: styles.Hgroup },
						_react2['default'].createElement(
							'h1',
							{ className: styles.Name },
							article.fullname
						),
						article.titles && _react2['default'].createElement(
							'h2',
							{ className: styles.Title },
							article.titles
						)
					)
				),
				_react2['default'].createElement(
					'div',
					{ className: styles.Content },
					_react2['default'].createElement('article', { className: contentStyles, dangerouslySetInnerHTML: { __html: article.biography } }),
					_react2['default'].createElement(
						'aside',
						{ className: styles['Content--sidebar'] },
						_react2['default'].createElement(
							'div',
							{ className: styles.ContributorNav },
							_react2['default'].createElement(
								'h3',
								{ className: styles.ContributorHeader },
								'Contributors'
							),
							_react2['default'].createElement(
								'ul',
								{ className: styles.ContributorList },
								articles.map(function (person, index) {
									return _react2['default'].createElement(
										'li',
										{ key: index, className: styles.ContributorItem },
										_react2['default'].createElement(
											_reactRouter.Link,
											{ className: styles.ContributorLink, to: '/contributors/' + person.slug },
											person.fullname
										)
									);
								})
							)
						)
					)
				)
			)
		);
	};

	_createClass(Contributors, null, [{
		key: 'propTypes',
		value: {
			articles: _react.PropTypes.array,
			articlesError: _react.PropTypes.string,
			articlesLoading: _react.PropTypes.bool,
			location: _react.PropTypes.object,
			params: _react.PropTypes.object
		},
		enumerable: true
	}]);

	var _Contributors = Contributors;
	Contributors = _reactRedux.connect(function (state) {
		return {
			articles: state.contributors.data,
			articlesError: state.contributors.error,
			articlesLoading: state.contributors.loading
		};
	})(Contributors) || Contributors;
	return Contributors;
})(_react.Component);

exports['default'] = Contributors;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Contributors/Contributors.js
 ** module id = 701
 ** module chunks = 0
 **/